<template>
  <div class="koyou-keiyaku-tenpufile edit-item" v-if="editingData">

    <div class="head"><b>添付ファイル</b></div>
    <input-files v-model="editingData.tenpufiles" :base-url="baseurl" name="uploadfile" accept=".png,.jpg,.pdf,.xlsx,.docx" :disabled="disabled"></input-files>
</div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import Config from '@/const/Config';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
      baseurl: Config.THUMB_BASE_URL
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/form/input-file.scss';
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>